import React from 'react';
import styled from 'styled-components';

import {
  colorSecondary,
  colorBlueGray,
  colorPrimary,
  colorWhite,
} from 'styles';

const getSize = ({ size }) => {
  switch (size) {
    case 'lg':
      return '24px';
    case 'md':
    default:
      return '16px';
  }
};

export const Icon = styled(
  ({ checked, invalid, checkPosition, size, ...props }) => <span {...props} />
)`
  position: absolute;
  top: 45%;
  transform: translateY(-45%);
  width: ${getSize};
  height: ${getSize};

  ${({ checkPosition }) => {
    switch (checkPosition) {
      case 'start':
        return 'left: 0;';
      case 'end':
      default:
        return ' right: 0;';
    }
  }}

  &:before {
    content: '';
    width: ${getSize};
    height: ${getSize};
    left: 0;
    position: absolute;
    transition: border-color 0.3s;
    border-style: solid;
    border-width: 1px;
    background-color: ${colorWhite};

    border-radius: ${({ size }) => {
      switch (size) {
        case 'lg':
          return '4px';
        case 'md':
        default:
          return '2px';
      }
    }};

    ${({ disabled, checked, invalid }) => {
      if (disabled) {
        return 'border-color: #ececec';
      }

      if (!checked) {
        return `
          border-color: ${
            invalid ? colorSecondary : colorBlueGray
          };             
        `;
      }

      return `     
          border-color: ${colorPrimary};    
          background-color: ${colorPrimary}; 
      `;
    }}
  }

  &:after {
    content: '';
    position: absolute;
    display: ${({ checked }) => {
      if (checked) {
        return 'block';
      }

      return 'none';
    }};
    border-color: ${colorWhite};
    border-style: solid;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) translateY(-45%);
    transform-origin: right;

    ${({ size }) => {
      switch (size) {
        case 'lg':
          return `
            top: calc(45% - 1px);
            width: 6px;
            height: 12px;
            left: 4px;
          `;
        case 'md':
        default:
          return `
            top: 45%;
            width: 5px;
            height: 9px;
            left: 2px;
          `;
      }
    }}
  }
`;

export default Icon;
